import React from 'react';
import PropTypes from 'prop-types';
import '../Hobbies.scss';

function HobbyContainer({ icon, name }) {
  return (
    <div className='hobbies-item'>
      <div className='hobbies-icons'>{icon}</div>
      <p className='hobbies-name'>{name}</p>
    </div>
  );
}

HobbyContainer.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
};

export default HobbyContainer;
